import Mobiles_Jaw_QJ340 from './icon-images/Mobiles_Jaw_QJ340.png';
import Mobiles_Jaw_QJ340_NF from './icon-images/Mobiles_Jaw_QJ340_NF.png';
import Mobiles_Jaw_UJ300 from './icon-images/Mobiles_Jaw_UJ300.png';
import Mobiles_Jaw_UJ313 from './icon-images/Mobiles_Jaw_UJ313.png';
import Mobiles_Jaw_UJ440i from './icon-images/Mobiles_Jaw_UJ440i.png';
import Mobiles_Jaw_UJ640E from './icon-images/Mobiles_Jaw_UJ640E.png';
import Mobiles_Jaw_UJ440i_HS_OC from './icon-images/Mobiles_Jaw_UJ440i_HS_OC.png';
import Mobiles_Jaw_UJ443E from './icon-images/Mobiles_Jaw_UJ443E.png';
import Mobiles_Jaw_UJ473 from './icon-images/Mobiles_Jaw_UJ473.png';

export const getImageMobileJaw = (configKey: number, model: string) => {
  switch (model) {
    case 'QJ241':
      switch (configKey) {
        case 0:
          return Mobiles_Jaw_QJ340;
        case 1:
          return Mobiles_Jaw_QJ340_NF;
        default:
          return Mobiles_Jaw_QJ340;
      }
    case 'QJ341':
      switch (configKey) {
        case 0:
          return Mobiles_Jaw_QJ340;
        case 1:
          return Mobiles_Jaw_QJ340_NF;
        default:
          return Mobiles_Jaw_QJ340;
      }
    case 'QJ341+':
      switch (configKey) {
        case 0:
          return Mobiles_Jaw_QJ340;
        case 1:
          return Mobiles_Jaw_QJ340_NF;
        case 2:
          return Mobiles_Jaw_QJ340_NF;
        default:
          return Mobiles_Jaw_QJ340;
      }
    case 'UJ440IVGF':
      switch (configKey) {
        case 0:
          return Mobiles_Jaw_UJ440i;
        case 1:
          return Mobiles_Jaw_UJ440i;
        case 2:
          return Mobiles_Jaw_UJ440i_HS_OC;
        case 3:
          return Mobiles_Jaw_UJ440i_HS_OC;
        default:
          return Mobiles_Jaw_UJ440i;
      }
    case 'UJ440IVGFUS':
      switch (configKey) {
        case 0:
          return Mobiles_Jaw_UJ440i;
        case 1:
          return Mobiles_Jaw_UJ440i;
        case 2:
          return Mobiles_Jaw_UJ440i_HS_OC;
        case 3:
          return Mobiles_Jaw_UJ440i_HS_OC;
        default:
          return Mobiles_Jaw_UJ440i;
      }
    case 'UJ440E':
      switch (configKey) {
        case 0:
          return Mobiles_Jaw_UJ440i;
        case 1:
          return Mobiles_Jaw_UJ440i;
        default:
          return Mobiles_Jaw_UJ440i;
      }
    case 'UJ443EVGF':
    case 'UJ443EVGFUS':
      return Mobiles_Jaw_UJ443E;
    case 'UJ640EVGFUS':
      switch (configKey) {
        case 0:
          return Mobiles_Jaw_UJ640E;
        case 1:
          return Mobiles_Jaw_UJ640E;
        default:
          return Mobiles_Jaw_UJ640E;
      }
    case 'UJ473':
      return Mobiles_Jaw_UJ473;
    case 'UJ210':
      switch (configKey) {
        case 0:
          return Mobiles_Jaw_UJ300;
        case 1:
          return Mobiles_Jaw_UJ300;
        case 2:
          return Mobiles_Jaw_UJ300;
        default:
          return Mobiles_Jaw_UJ300;
      }
    case 'UJ300':
      switch (configKey) {
        case 0:
          return Mobiles_Jaw_UJ300;
        case 1:
          return Mobiles_Jaw_UJ300;
        case 2:
          return Mobiles_Jaw_UJ300;
        default:
          return Mobiles_Jaw_UJ300;
      }
    case 'UJ310':
      switch (configKey) {
        case 0:
          return Mobiles_Jaw_UJ300;
        case 1:
          return Mobiles_Jaw_UJ300;
        case 2:
          return Mobiles_Jaw_UJ300;
        default:
          return Mobiles_Jaw_UJ300;
      }
    case 'UJ313':
      switch (configKey) {
        case 0:
          return Mobiles_Jaw_UJ313;
        case 1:
          return Mobiles_Jaw_UJ313;
        case 2:
          return Mobiles_Jaw_UJ313;
        default:
          return Mobiles_Jaw_UJ313;
      }
    default:
      return '';
  }
};
